(function () {
  'use strict';

  if (window.__rcCardImageNavFix) return;
  window.__rcCardImageNavFix = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.product-card_media a[href]');
    if (!link) return;
    if (!link.hasAttribute('data-recharge-cart-trigger-observer') && link.getAttribute('role') !== 'button') return;

    event.stopImmediatePropagation();

    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    event.preventDefault();
    window.location.href = link.href;
  }, true);
})();
